module.exports = __webpack_public_path__ + "assets/img/3024.8344ac4c.svg";